import React from 'react';
import { Loader2 } from 'lucide-react';
import styles from './AuthButton.module.css';

type AuthButtonVariant = 'primary' | 'secondary' | 'ghost' | 'google';

interface AuthButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: AuthButtonVariant;
  loading?: boolean;
  fullWidth?: boolean;
  leftIcon?: React.ReactNode;
}

const AuthButton: React.FC<AuthButtonProps> = ({
  variant = 'primary',
  loading = false,
  fullWidth = false,
  leftIcon,
  disabled,
  className = '',
  children,
  ...rest
}) => (
  <button
    {...rest}
    disabled={disabled || loading}
    className={`${styles.button} ${styles[variant]} ${fullWidth ? styles.fullWidth : ''} ${className}`.trim()}
  >
    {loading ? <Loader2 className={styles.spinner} size={19} aria-hidden="true" /> : leftIcon}
    <span>{children}</span>
  </button>
);

export default AuthButton;
